import { computed } from 'mobx';
import { BaseStore } from './BaseStore';
import { Stores } from '../models/Stores';
import { Icons } from '../models/configuration/accessibility/icons';
import { Accessibility } from '../models/configuration/Accessibility';
import { DataStore } from './DataStore';

export class AccessibilityStore extends BaseStore {
    dataStore: DataStore;

    constructor(stores: Stores) {
        super(stores);
        this.dataStore = stores.data;
    }

    @computed
    get hasAccessibility(): boolean {
        return this.accessibilityConfig !== undefined;
    }

    @computed
    get accessibilityConfig(): Accessibility {
        const { config } = this.dataStore;
        return (
            config && config.globalConfig && config.globalConfig.accessibility
        );
    }

    @computed
    get icons(): Icons {
        if (this.hasAccessibility) {
            const { icons } = this.accessibilityConfig;
            return icons;
        }
    }
}



// WEBPACK FOOTER //
// ./src/stores/AccessibilityStore.ts